import React from "react";
import { LabelDate, LabelDollarFormatted, LabelString } from "@loanbossinc/component-library";

export const dashboardBodyDataTableClosedDealColumns = [
  {
    id: "name",
    label: "Deal",
    path: "name",
    Cell: value => <LabelString value={value} />
  },
  {
    id: "targetedClosingDate",
    label: "Targeted Closing Date",
    path: "targetedClosing",
    Cell: value => <LabelDate value={value} />
  },
  {
    id: "purchasePrice",
    label: "Purchase Price",
    path: "purchasePrice",
    Cell: value => (
      <LabelDollarFormatted value={value} decimals={0} />
    )
  },
  {
    id: "unit",
    label: "Units / Sq. Ft.",
    path: "unit",
    Cell: value => <LabelString value={value} />
  }
];
